<template>
  <div>
    <header v-if="!isMobiledevice()" class="headers">
      <div class="containers" v-bind:class="{'bazazHead':isBajajMarketingId}">
        <div class="logo" v-if="!isMobiledevice()">
          <a  class="logopb" v-if="!isPospUtmSource" href="https://www.policybazaar.com">
          </a>
          <a v-if="isPospUtmSource">
            <img
              style="max-height:33px;margin-top:0px"
              alt="logo"
              class="policylogo"
              title="Policy Bazaar"
              src="https://static.pbcdn.in/term-cdn/images/vue/pbp_web_logo.svg" />
          </a>
        </div>
        <div class="claim-ratio" v-if="!isPospUtmSource">
            <a target="_blank"  v-bind:href="getTermDecalLik" > <img src="https://static.pbcdn.in/term-cdn/images/vue/claim.png" /> Claim Assistance</a>
        </div>
      </div>
    </header>

    <header v-else class="header-mobs" v-bind:class="{'bazazHead':isBajajMarketingId}">
      <div class="logo">
        <a class="logopb">
         <!-- <img
            alt="policy bazaar"
            src="https://static.pbcdn.in/term-cdn/images/vue/logo.png"/> -->
        </a>
         Term Insurance
      </div>
    <!--  <div class="claim-ratio">
            <a target="_blank"  v-bind:href="getTermDecalLik" > <img src="https://static.pbcdn.in/term-cdn/images/vue/claim.png" /> Claim Assistance</a>
        </div> -->
      <!-- <div @click="openTalktoExpert" class="openTalktoExpert">
         <img
              class="tool-icon"
              alt="toll free"
              src="data:image/svg+xml;base64,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"
            />
            <i class="phone_icon">Call us</i>
      </div> -->
    </header>

    <!-- Talk to expert -->
    <!-- <modal
      class="modal-open"
      width="100%"
      height="100%"
      :adaptive="true"
      :clickToClose="true"
      :classes="['modal-open']"
      name="talk-to-expert"
    >
      <div id="emailModel">
        <div class="modal-content">
          <div class="modal-header"></div>
          <div class="modal-body">
            <button @click="hide" id="closeSidepage">X</button>
            <div class="callHeading">
              <span class="circle">
                <img
                  alt="circle"
                  src="data:image/svg+xml;base64,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"
                />
              </span>
              <h3
                v-bind:class="{'talkexpert':!talkToExpertCalled}"
              >{{talkToExpertCalled ? 'We will call you back!' : 'You can talk to us directly on below toll free numbers'}}</h3>
            </div>
            <div class="callContaint">
              <p
                v-bind:class="{'hidetalkexpert':!talkToExpertCalled}"
              >You can reach us directly on the below toll-free numbers:</p>
              <ul>
                <li>
                  <label>Looking To Buy ( Sales)</label>
                  <a href="tel:1800-208-8787" v-if="!isQuotesPage">
                    <img
                      alt="call"
                      src="data:image/svg+xml;base64,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"
                    />
                    1800-208-8787
                  </a>
                  <template v-else>
                    <a href="tel:1800-419-7713">
                      <img
                        alt="call"
                        src="data:image/svg+xml;base64,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"
                      />
                      1800-419-7713
                    </a>
                  </template>
                </li>
                <li>
                  <label>Have Already Paid (Service)</label>
                  <a href="tel:1800-258-5970">
                    <img
                      alt="call"
                      src="data:image/svg+xml;base64,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"
                    />
                    1800-258-5970
                  </a>
                </li>
                <li>
                  <label>For NRI's</label>
                  <a href="tel:+91 124-6656508">
                    <img
                      alt="call"
                      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU1ICg3ODA3NikgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+7qGtPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkRlc2t0b3AtSEQtQ29weS0yMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY5Ni4wMDAwMDAsIC0yNTcuMDAwMDAwKSIgZmlsbD0iIzI2ODRGRiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTcwMCwyNjUuNjQgQzcwMC44MTc3ODIsMjY3LjIwNDQ1MiA3MDEuODU3NzcxLDI2OC42MTc3NzEgNzAzLjEyLDI2OS44OCBDNzA0LjM4MjIyOSwyNzEuMTQyMjI5IDcwNS43OTU1NDgsMjcyLjE4MjIxOCA3MDcuMzYsMjczIEw3MDkuODEzMzMzLDI3MC41NDY2NjcgQzcwOS45NTU1NTYsMjcwLjM4NjY2NiA3MTAuMTMzMzMyLDI3MC4yOCA3MTAuMzQ2NjY3LDI3MC4yMjY2NjcgQzcxMC41NjAwMDEsMjcwLjE3MzMzMyA3MTAuNzY0NDQzLDI3MC4xOTExMTEgNzEwLjk2LDI3MC4yOCBDNzEyLjEzMzMzOSwyNzAuNjg4ODkxIDcxMy40NDg4ODIsMjcwLjg5MzMzMyA3MTQuOTA2NjY3LDI3MC44OTMzMzMgQzcxNS4yMDg4OSwyNzAuODkzMzMzIDcxNS40NjY2NjYsMjcwLjk5OTk5OSA3MTUuNjgsMjcxLjIxMzMzMyBDNzE1Ljg5MzMzNCwyNzEuNDI2NjY4IDcxNiwyNzEuNjg0NDQzIDcxNiwyNzEuOTg2NjY3IEw3MTYsMjc1LjkwNjY2NyBDNzE2LDI3Ni4yMDg4OSA3MTUuODkzMzM0LDI3Ni40NjY2NjYgNzE1LjY4LDI3Ni42OCBDNzE1LjQ2NjY2NiwyNzYuODkzMzM0IDcxNS4yMDg4OSwyNzcgNzE0LjkwNjY2NywyNzcgQzcxMi4zNDY2NTQsMjc3IDcwOS44OTMzNDUsMjc2LjUwMjIyNyA3MDcuNTQ2NjY3LDI3NS41MDY2NjcgQzcwNS4yODg4NzgsMjc0LjU0NjY2MiA3MDMuMjg4ODk4LDI3My4xOTU1NjQgNzAxLjU0NjY2NywyNzEuNDUzMzMzIEM2OTkuODA0NDM2LDI2OS43MTExMDIgNjk4LjQ1MzMzOCwyNjcuNzExMTIyIDY5Ny40OTMzMzMsMjY1LjQ1MzMzMyBDNjk2LjQ5Nzc3MywyNjMuMTA2NjU1IDY5NiwyNjAuNjUzMzQ2IDY5NiwyNTguMDkzMzMzIEM2OTYsMjU3Ljc5MTExIDY5Ni4xMDY2NjYsMjU3LjUzMzMzNCA2OTYuMzIsMjU3LjMyIEM2OTYuNTMzMzM0LDI1Ny4xMDY2NjYgNjk2Ljc5MTExLDI1NyA2OTcuMDkzMzMzLDI1NyBMNzAxLjAxMzMzMywyNTcgQzcwMS4zMTU1NTcsMjU3IDcwMS41NzMzMzIsMjU3LjEwNjY2NiA3MDEuNzg2NjY3LDI1Ny4zMiBDNzAyLjAwMDAwMSwyNTcuNTMzMzM0IDcwMi4xMDY2NjcsMjU3Ljc5MTExIDcwMi4xMDY2NjcsMjU4LjA5MzMzMyBDNzAyLjEwNjY2NywyNTkuNTUxMTE4IDcwMi4zMTExMDksMjYwLjg2NjY2MSA3MDIuNzIsMjYyLjA0IEM3MDIuNzczMzM0LDI2Mi4yMzU1NTcgNzAyLjc4MjIyMiwyNjIuNDM5OTk5IDcwMi43NDY2NjcsMjYyLjY1MzMzMyBDNzAyLjcxMTExMSwyNjIuODY2NjY4IDcwMi42MTMzMzQsMjYzLjA0NDQ0NCA3MDIuNDUzMzMzLDI2My4xODY2NjcgTDcwMCwyNjUuNjQgWiIgaWQ9Iu6hrSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
                    />
                    +91 124-6656508
                  </a>
                </li>
              </ul>
              <p class="copy">Use Registered No. Only*</p>
            </div>
          </div>
        </div>
      </div>
    </modal> -->
  </div>
</template>

<script lang="ts">
/* tslint:disable */

import { computed, defineComponent, ref} from 'vue';
import { useRoute } from 'vue-router';
import prequotesService from "../services/prequotesService";
import appFixedDiv from "@/common/directives/appFixedDiv";
import environment from "@/environment";

// @Component({ directives: { appFixedDiv } })
// export default class SjbHeaderComponent extends Vue {
//   @Prop({ default: false })
//   mobileDevice!: boolean;
//   prefilldata!: any;
//   get isMobiledevice() {
//     return this.mobileDevice;
//   }
//   isQuotesPage: boolean = false;
//   talkToExpertCalled: boolean = false;
  // get isBajajMarketingId(){
  //     return this.$route.query["marketingId"] && this.$route.query["marketingId"]  == "11" ? true: false
  // }
  // get getTermDecalLik(){
  //   return environment.termClaim;
  // }
  // get isPospUtmSource(){
  //   return this.$route.query["OfflineToken"] ? true : false;
  // }
//   openTalktoExpert() {
//     this.isQuotesPage = this.$route.query["enquiryId"] != undefined;
//     this.talkToExpertCalled = false;
//     this.prefilldata = prequotesService.prefillprequotedata;
//     if (
//       this.prefilldata &&
//       this.prefilldata["matrixLeadId"] &&
//       this.prefilldata["encryptedMobileNo"] &&
//       prequotesService.checkForClickToCall(this.prefilldata["matrixLeadId"])
//     ) {
//       this.talkToExpertCalled = true;
//       prequotesService
//         .clickToCall(
//           this.prefilldata["encryptedMobileNo"],
//           this.prefilldata["matrixLeadId"]
//         )
//         .then((response: any) => {
//           prequotesService.setExpertClickToCallCookie(
//             this.prefilldata["matrixLeadId"]
//           );
//         });
//     }
//     // this.commonService.openTalkToExpertModal(TalkExpertComponent,isQuotesPage, talkToExpertCalled);
//     // this.$modal.show(talkToExpert,{'isQuotesPage':isQuotesPage,'talkToExpertCalled':talkToExpertCalled});
//     this.$modal.show("talk-to-expert");
//   }

//   hide() {
//     this.$modal.hide("talk-to-expert");
//   }

//   get isCrmLink() {
//     // return environment.offerIds.includes(+this.$route.query["offerId"]);
//      return this.$route.query["isCrm"] && this.$route.query["isCrm"]=='true'
//   }
// }
export default defineComponent({
  name:"SjbHeaderComponent",
  directives: { appFixedDiv },
  props: {
    mobileDevice: {
      type: Boolean,
      default: false,
    },
  },
  setup(props:any){
    const prefilldata = ref(null);
    const isQuotesPage = ref(false);
    const talkToExpertCalled = ref(false);
    const route = useRoute(); // Access the current route
      const openTalktoExpert = () =>  {
          isQuotesPage.value = route.query["enquiryId"] != undefined;
          talkToExpertCalled.value = false;
          prefilldata.value = prequotesService.prefillprequotedata;
          if (
            prefilldata.value &&
            prefilldata.value["matrixLeadId"] &&
            prefilldata.value["encryptedMobileNo"] &&
            prequotesService.checkForClickToCall(prefilldata.value["matrixLeadId"])
          ) {
            talkToExpertCalled.value = true;
            prequotesService
              .clickToCall(
                prefilldata.value["encryptedMobileNo"],
                prefilldata.value["matrixLeadId"]
              )
              .then((response: any) => {
                prequotesService.setExpertClickToCallCookie(
                  prefilldata.value!["matrixLeadId"]
                );
              });
          }
          // this.$modal.show("talk-to-expert"); // Need to change 
        }
      const isBajajMarketingId = ()=>{
        return route.query["marketingId"] && route.query["marketingId"]  == "11" ? true: false
      }
      const getTermDecalLik = computed(()=>{
        return environment.termClaim;
      })
      const isPospUtmSource = computed(()=>{
        return route.query["OfflineToken"] ? true : false;
      })
      const hide =()=> {
          // this.$modal.hide("talk-to-expert");
      }
      const isCrmLink =()=> {
        return route.query["isCrm"] && route.query["isCrm"]=='true'
      }
      return {
        openTalktoExpert,
        isBajajMarketingId,
        getTermDecalLik,
        isPospUtmSource,
        hide,
        isCrmLink,
        talkToExpertCalled,
        isQuotesPage
      };
    },
    methods:{
      isMobiledevice(){
        return this.mobileDevice;
    }
  }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
/* h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
} */

.prequotes .headers {
  width: 100%;
  float: left;
  background: transparent;
  border: 0;
  padding-top:0px;
  height: 44px;
  top: 0;
  z-index: 999;
  transition: all 0.5s ease;
  box-shadow: 0px 3px 6px #00000029;
      position: relative;

}
.prequotes .containers {
  width: 1080px;
  margin: 0 auto;
  max-width: 100%;
}

.logopb {width: 152px; float:left;  background: var(--logos) no-repeat 0px 0px; height: 40px; background-size: cover;}


.prequotes .headers.fixed {
  position: fixed;
  animation: headerAnimation 0.6s forwards;
  padding-top: 2px;
  background: #fff;
  z-index: 999;
  
}
.containers  .pnb {display: inline-block;}
.bazazHead.containers  .pnb{display: none;}
.bazazHead.containers  .bazaz{display:inline-block; cursor: default;}
.bazazHead.containers  .bazaz img {margin-top:1px;  margin-left: 10px;}
.containers  .bazaz{display:none;}


@keyframes headerAnimation {
  0% {
    -webkit-transform: translateY(-160px);
    transform: translateY(-160px);
  }
  100% {
    -webkit-transform: translateY(0);
    box-shadow: 0 2px 30px 1px #dbdde1;
    transform: translateY(0);
  }
}

.prequotes .pbcontact .phone_icon:after {
  position: absolute;
  content: "";
  left: 110%;
  top: 10px;
  width: 5px;
  height: 5px;
  border: solid #0652dd;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.prequotes .formbox-inner {
  width: 100%;
  float: left;
  position: relative;
  height: 560px;
  background: #fff;
  box-shadow: 0 1px 30px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  margin-top: 26px;
}

.prequotes .logo {
  float: left;
  padding: 0;
  width: 60%;
      height: 40px;
  
}

.prequotes .logo .pblogos {position: relative;}
.prequotes .logo .pblogos img{margin-top: 12px;}


 .prequotes .logo .policylogo{    margin-top: 12px;}

.prequotes .logo img {
  max-width:84px;
  width:auto;
  margin-top:9px;
}

.prequotes .claim-ratio {
     width: auto;
    padding-top: 8px;
    padding-left: 0;
    text-align: right;
    height: 34px;
    display: flex;
    justify-content: flex-end;
}

.circle {
  background-color: #ffffff;
  border: 0;
  width: 38px;
  height: 38px;
  float: right;
  margin-top: 5px;
}
.circle {
  background-color: #d5e6ff;
  border: 10px solid #e9f2ff;
  width: 50px;
  height: 50px;
  float: none;
}

.prequotes .claim-ratio a {
  padding-top: 2px;
  display: inline-block;
  letter-spacing: 0;
  height: 36px;
  text-decoration: none;
  cursor: pointer;
  color: #0652dd;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
}

.prequotes .claim-ratio a img {
  float: left;
  position: relative;
  top: 0;
  right:0px;
}

.prequotes .quotetop-rights {
  float: left;
  padding-left: 2%;
  width: 17%;
  height: 40px;
  position: relative;
  display: none;
}

.prequotes .quotetop-rights:after {
      position: absolute;
    content: "";
    background: #67A8FF;
    -webkit-transform: rotate(45deg);
    transform: rotate(-24deg);
    height: 100px;
    width: 220px;
    left: 7px;
    z-index: 9;
    top: -58px;
}
 .prequotes .quotetop-rights a span {text-align: left;color:#fff; font-size:10px;    display: inline-block;}
.prequotes .quotetop-rights a {    transform: rotate(0);
    position: relative;
    z-index: 999;    padding-top: 6px;
    display: inline-block;
    padding-right: 6px;
}
    .prequotes .quotetop-rights a img {    transform: rotate(90deg);
    position: relative;
    top:-3px;
    right:6px;
    width: 14px;}

.prequotes .pbcontact {
  float: left;
  width: 100%;
  height: 35px;
  padding-top: 4px;
  position: relative;
}

.prequotes .pbcontact .tool-icon {
  float: left;
  padding: 7px 0 6px 10px;
}

.prequotes .pbcontact .phone_icon {
  float: left;
  padding-left: 8px;
  font-weight: 600;
  padding-top: 5px;
  cursor: pointer;
  color: #0652dd;
  position: relative;
}

i {
  font-style: normal;
}

.top-title {
  width: 65%;
  float: left;
  padding-left: 22px;
}

.top-title h2 {
  text-align: center;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;
  padding-top: 10px;
}

.prequotes .toll-free {
  float: left;
  padding-top: 14px;
  width: 100%;
}

.prequotes .toll-free .number-infos {
  position: absolute;
  right: -1px;
  opacity: 0;
  visibility: hidden;
  top: 37px;
  background: #fff;
  width: 228px;
  padding: 0;
  box-shadow: 0 2px 13px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.prequotes .quotetop-rights:hover .number-infos {
  border: 1px solid #0652dd;
  opacity: 1;
  z-index: 999;
  visibility: visible;
}

.footer {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 10px;
  margin-top: 25px;
}

.footer p {
  margin: 0;
  color: var(--footertext);
  line-height: 16px;
  font-size: 9px;
}

.footer p a {
  color: #157bfb;
  text-decoration: none;
  font-weight: 400;
}

.header-mobs {
  display: none;
}




@media (min-width:1025px) and (max-width: 1920px) {

.logo {float: left !important;
    display: block  !important;}


.logo a {float: left;}
.logo .pnb{position:relative;  padding-left: 10px;
    margin-left: 10px;}
    .logo .pnb:before{    position: absolute;
    content: "";
    width: 1px;
    height: 20px;
    background: #e6e2e2;
    left: 0;
    top: 10px;}
.prequotes .logo img {    max-width:126px;
    width: auto;    margin-top: 10px;}

}


@media (min-width: 320px) and (max-width: 1024px) {
  body {
    margin: 0;
  }
  .openTalktoExpert { height:40px; line-height:40px; text-align:right; padding-right:10px; }
.phone_icon { color: #0165ff;}
  .logopb {height:35px; width:32px}
  .openTalktoExpert img {position: relative;
    top: 2px;
    right: 5px;}

  .prequotes .claim-ratio a{font-size: 10px;}
  .prequotes .claim-ratio {    padding-top: 7px;
    padding-right: 6px;}

  .bazazHead.containers  .bazaz img {margin-top:3px; }

  .header-mobs .pnb {margin-left: 17px;}

  .prequotes {
    background: #fff;
  }

  .prequotes .right-section {
    width: 100%;
  }
  .prequotes .logo{padding-left:15px; line-height: 36px;}
  .prequotes .logo a{display: block; float: left;     background-position: -142px 5px;}

   .header-mobs .pnb{display:inline-block;}
    .header-mobs.bazazHead .pnb{display: none;}

     .prequotes .header-mobs .logo  .bazaz{display:none;}
      .prequotes .header-mobs.bazazHead .logo  .bazaz{display:inline-block;}

    .header-mobs.bazazHead .bazaz{display:inline-block;}
    .prequotes  .header-mobs.bazazHead .logo .bazaz img {margin-top:3px;}
  .prequotes .header-mobs {
    display: block;
    padding:0px;
    background: #fff;
        height: 40px;
   box-shadow: 0px 3px 10px #00000029;
       position: relative;
    z-index: 9;
        overflow: hidden;
  }
  .title {
    text-align: center;
    width: 100%;
    float: left;
    position: absolute;
    text-transform: uppercase;
    font-weight: 600;
    padding-top: 10px;
    left: 0;
  }
  .prequotes .loader {
    top: 150px;
  }

  .prequotes .w--spinner > div {
    width: 8px;
    height: 8px;
  }
  .prequotes .quotetop-rights {
    float: right;
    width:95px;
  }

  .prequotes .pbcontact {
    padding-top: 0;
  }

  .prequotes .headers {
    display: none;
  }

  .prequotes .formbox-inner {
    margin-top: 0;
    box-shadow: none;
    background: 0 0;
  }

  .mobile_call {
    height: 41px;
    display: block;
    top: 0;
    background: #0775fb;
    color: #fff;
    width: 100%;
    padding: 0;
    border-radius: 0;
    font-size: 10px;
  }

  .mobile_call img {
    position: relative;
    float: left;
    width: 20px;
    right: -6px;
    top: 12px;
  }

  .mobile_call span.txt {
    display: block;
    float: left;
    text-align: left;
    position: relative;
    top: 10px;
    left: 10px;
    width: 48px;
    line-height: 12px;
    font-weight: 400;
    font-style: normal;
  }
}

@media (max-width: 360px) {
  .prequotes .quotetop-rights {
    width: 25%;
  }
}

a {
  color: #42b983;
}

#emailModel {
  width: 675px;
  margin: 80px auto 0;
  min-height: 338px;
  background: #fbfbfb;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.modal-header {
  display: none;
}
.callHeading {
  width: 80%;
  margin: 8px auto 0;
  text-align: center;
  border-bottom: 1px solid #dcdcdc;
  box-sizing: content-box;
}
.circle {
  position: relative;
  background-color: #d5e6ff;
  border: 10px solid #e9f2ff;
  width: 50px;
  height: 50px;
  border-radius: 100px;
  display: inline-block;
  box-sizing: content-box;
}
.circle img {
  position: absolute;
  text-align: center;
  top: 15px;
  left: 15px;
}
.callHeading h3 {
  text-align: center;
  font-size: 24px;
  color: #2684ff;
  padding: 14px 0 25px;
  font-weight: 600;
}
.callContaint {
  text-align: center;
  width: 100%;
  float: left;
}
.callContaint p {
  color: #212121;
  font-size: 16px;
  font-weight: 500;
  margin: 20px 0 10px;
}
.callContaint ul {
  width: 100%;
  float: left;
  margin: 10px 0;
  margin-left: 4%;
}
.callContaint ul li {
  list-style: none;
  float: left;
  width: 33%;
}
.callContaint ul li label {
  display: block;
  text-align: left;
  margin-bottom: 7px;
  color: #212121;
  font-size: 13px;
  font-weight: 500;
}
.callContaint ul li a {
  cursor: pointer;
  text-align: left;
  display: block;
  color: #2684ff;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
}
.callContaint ul li a img {
  position: relative;
  top: -1px;
  max-width: 16px;
  left: -1px;
}
.copy {
  width: 100%;
  float: left;
  margin: 30px 0 0px !important;
  text-align: center;
  font-size: 12px !important;
  color: #696969 !important;
}
.callHeading .talkexpert {
  font-size: 18px;
}
.hidetalkexpert {
  display: none;
}

#emailModel .modal-body #closeSidepage {
  float: right;
  cursor: pointer;
  border: 0;
  font-size: 16px;
  font-weight: 600;
  border-radius: 100%;
  width: 25px;
  height: 25px;
  padding: 2px;
  background: transparent;
  color: var(--closepopupcolor);
  position: absolute;
  right: 3px;
  top: 2px;
}
#emailModel {
  -webkit-animation-duration: 0.85s;
  animation-duration: 0.85s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-name: bounceInUp;
  animation-name: bounceInUp;
}

@keyframes bounceInUp {
  0%,
  30%,
  60%,
  80%,
  100% {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 200px, 0);
    transform: translate3d(0, 200px, 0);
  }
  30% {
    opacity: 1;
    -webkit-transform: translate3d(0, -40px, 0);
    transform: translate3d(0, -40px, 0);
  }
  60% {
    -webkit-transform: translate3d(0, 4px, 0);
    transform: translate3d(0, 4px, 0);
  }
  80% {
    -webkit-transform: translate3d(0, -2px, 0);
    transform: translate3d(0, -2px, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
@-webkit-keyframes bounceInUp {
  0%,
  30%,
  60%,
  80%,
  100% {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 200px, 0);
    transform: translate3d(0, 200px, 0);
  }
  30% {
    opacity: 1;
    -webkit-transform: translate3d(0, -40px, 0);
    transform: translate3d(0, -40px, 0);
  }
  60% {
    -webkit-transform: translate3d(0, 4px, 0);
    transform: translate3d(0, 4px, 0);
  }
  80% {
    -webkit-transform: translate3d(0, -2px, 0);
    transform: translate3d(0, -2px, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@media all and (min-width: 320px) and (max-width: 1024px) {
  #emailModel {
    width: 96%;
  }
  .modal-body {
    padding: 0 10px;
  }
  .callHeading .talkexpert {
    font-size: 14px;
    font-weight: normal !important;
  }
  .circle img {
    text-align: center;
    top: 10px;
    left: 9px;
    width: 16px;
  }
  .modal-body #closeSidepage {
    right: -7px;
    top: -5px;
  }
  .circle {
    background-color: #fff;
    border: 0;
    width: 34px;
    height: 34px;
    margin-top: 3px;
  }
  .callHeading {
    width: 90%;
  }
  .callHeading h3 {
    font-size: 18px;
    padding: 14px 0 16px;
    font-weight: 600 !important;
  }
  .callContaint p {
    font-size: 12px;
    margin: 20px 0 20px;
  }
  .callContaint ul {
    margin-left: 10px;
  }
  .callContaint ul li {
    margin-bottom: 5px;
    width: 50%;
  }
  .callContaint ul li label {
    font-size: 11px;
    margin-bottom: 4px;
    font-weight: 600;
  }
  .copy {
    margin: 0px 0 13px !important;
    font-size: 9px !important;
  }
  .callContaint ul li a {
    font-size: 16px;
    font-weight: 600;
  }
  .callContaint ul li a img {
    max-width: 13px;
  }
  .callContaint ul li:last-child {
    width: 90%;
    margin-top: 20px;
  }
  .callContaint ul li:last-child label {
    text-align: center;
  }
  .callContaint ul li:last-child a {
    text-align: center;
  }
}

@media (max-width: 360px) {
  .callContaint ul li label {
    font-size: 10px;
  }
}

@media (max-width: 320px) {
  .modal-body {
    padding: 0;
  }
  #emailModel {
    width: 97%;
    padding: 10px 5px;
  }
  .callContaint ul li label {
    font-size: 10px;
    margin-bottom: 3px;
  }
  .callContaint ul li a {
    font-size: 12px;
  }
}
</style>
